import {createContext} from 'react';

export type StepperContextValue = {
	activeStep: number;
	setActiveStep: (step: number) => void;
	next: () => void;
	back: () => void;
	addStep: (index: number) => void;
	removeStep: (index: number) => void;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const StepperContext = createContext<StepperContextValue>({} as StepperContextValue);
